// eslint-disable-next-line no-shadow
export let open;

export function setMediaPicker(mediaPicker) {
    open = mediaPicker.open;
}
